import { requestService } from '../../index';
import { updateFloorsList } from '../slices/floorsList.slice';

export const getFloorsList = (projectId: string) => async (dispatch) => {
	const floors = await requestService.get(`/projectConfig/floor?projectId=${projectId}`);
	dispatch(updateFloorsList({ floors: floors }));
};
